// ============================================================================
// BOQ — which sub-trades a trade group offers
// ============================================================================
// boq.subtrade_trade_groups records, per trade group, the canonical sub-trades
// ticked for it in the Subtrades column of the Taxonomies page's Trade group
// section. New item and the Edit modal use it
// to narrow the Chapter / sub-trade dropdown once a trade group is chosen.
//
// The rule, in one place so both modals agree:
//   • no trade group chosen, or one with nothing ticked → every sub-trade;
//   • otherwise → only the sub-trades ticked for it.
// `keepId` is the sub-trade already on the item: it stays in the list even if
// it is not ticked, flagged, so an existing classification is never hidden.
// ============================================================================

// rows: [{ subtrade_node_id, trade_group_node_id }] → Map tradeGroupId → Set(subtradeId)
export function buildSubtradeLinks(rows) {
  const byGroup = new Map();
  (rows || []).forEach((r) => {
    const tg = String(r.trade_group_node_id);
    if (!byGroup.has(tg)) byGroup.set(tg, new Set());
    byGroup.get(tg).add(String(r.subtrade_node_id));
  });
  return byGroup;
}

// A chapter's box in the Trade group's Subtrades checklist: 'all' when every
// sub-trade under it is ticked, 'some' when only part are (the box shows
// indeterminate), 'none' otherwise. A chapter with no sub-trades reads 'none'.
export function chapterTickState(subtradeIds, ticked) {
  const ids = subtradeIds || [];
  const n = ids.filter((id) => ticked?.has(String(id))).length;
  if (n === 0) return 'none';
  return n === ids.length ? 'all' : 'some';
}

// Returns { subtrades, filtered, outside }:
//   subtrades — the list to offer, in the order given;
//   filtered  — true when the trade group narrowed it;
//   outside   — the id of a kept sub-trade that is not ticked, else null.
export function subtradesForTradeGroup(subtrades, tradeGroupId, byGroup, keepId = null) {
  const list = subtrades || [];
  const ticked = tradeGroupId ? byGroup?.get(String(tradeGroupId)) : null;
  if (!ticked || ticked.size === 0) return { subtrades: list, filtered: false, outside: null };
  const keep = keepId ? String(keepId) : null;
  const out = list.filter((s) => ticked.has(String(s.id)) || String(s.id) === keep);
  const outside = keep && !ticked.has(keep) && out.some((s) => String(s.id) === keep) ? keep : null;
  return { subtrades: out, filtered: true, outside };
}
